import { combineReducers, Reducer } from 'redux';
import waivers from './waivers';

import { ComponentState, Action } from '../types';

const rootReducer: Reducer<ComponentState, Action<any>> = combineReducers({
  waivers,
});

export default rootReducer;
